import { render, staticRenderFns } from "./AssessmentPassStatus.vue?vue&type=template&id=190ce58e"
import script from "./AssessmentPassStatus.vue?vue&type=script&lang=js"
export * from "./AssessmentPassStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports